/**
 * CardItemSync component.
 * This component represents an individual card item for the Synchronized Knowledge .
 */

import { Box, Text, Flex, Image } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import CategoryBadge from '../Badge/CategoryBadge';
import { GetAuthData } from '../../../../misc/GetAuthData';
import { parseISO, isAfter } from 'date-fns';
import { PiStarFill, PiUsers } from 'react-icons/pi';

const CardItemSync = ({ item, spacing = true, accessFor }) => {
  const useAuth = GetAuthData();
  const history = useHistory();

  const urlDetail =
    accessFor === 'kursus-video'
      ? '/detail/kursus-video'
      : '/detail/pengetahuan';

  const classItem =
    accessFor === 'kursus-video' ? 'video-course-item' : 'pengetahuan-item';

  const startDate =
    item?.jadwal_mulai && parseISO(item?.jadwal_mulai.replace(' ', 'T'));
  const now = new Date();

  const isReadyToStart = isAfter(now, startDate as Date);

  const handleNavigate = () => {
    if (useAuth !== null) {
      window.location.href = `${urlDetail}/${item.id}`;
    } else {
      history.push('/login');
      window.scrollTo(0, 0);
    }
  };

  return (
    <Box
      h="auto"
      borderRadius="lg"
      overflow="hidden"
      border="1px solid"
      borderColor="gray.200"
      bg="white"
      mr={{ base: 0, md: spacing ? 8 : 0 }}
      _hover={{ shadow: 'lg', cursor: 'pointer' }}
      transition="all"
      transitionDuration="500ms"
      p={4}
      onClick={handleNavigate}
    >
      {/* Thumbnail */}
      <Box position="relative">
        <Image
          src={item.thumbnail}
          backgroundSize="cover"
          bgRepeat="no-repeat"
          style={{ aspectRatio: '2/1' }}
          rounded="lg"
          className={classItem}
          opacity={isReadyToStart ? '0.5' : '1'}
        />
        <Box position="absolute" right={4} top={4}>
          <CategoryBadge
            category={
              isReadyToStart ? 'Klinik Sudah Selesai' : 'Pendaftaran Dibuka'
            }
          />
        </Box>
      </Box>

      {/* Content */}
      <Box mt="4">
        <Flex direction="column" gap={2}>
          {/* Title */}
          <Text fontSize="lg" fontWeight="semibold">
            {item.title.length > 39
              ? item.title.substring(0, 39) + '...'
              : item.title}
          </Text>

          <Flex direction="row" alignItems="center" className="gap-2">
            {/* Rating */}
            <Flex alignItems="center" direction="row" className="gap-1">
              <Text fontSize="sm">{item.rata_rata_rating ?? 0}</Text>
              <PiStarFill size={13} className="text-yellow-500" />
            </Flex>
            <Text>|</Text>
            {/* Total Participant */}
            <Flex direction="row" alignItems="center" className="gap-1">
              <PiUsers size={13} />
              <Text>{item?.count_peserta} Peserta</Text>
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default CardItemSync;
